// frontend/src/pages/Auth/VerifyAccount.js

import React, { useState } from 'react';
import axiosInstance from '../../utils/axiosConfig';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const VerifyAccount = () => {
  const { verificationCode } = useParams();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('pending');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('pending');
    try {
      const { data } = await axiosInstance.post('/auth/verify', {
        email,
        verificationCode,
      });
      setStatus('success');
      setMessage(data.message);
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.message || 'Verifikation fehlgeschlagen.');
    }
  };

  if (status === 'success') {
    return (
      <motion.div
        className="max-w-md mx-auto bg-white p-8 rounded shadow text-center mt-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl text-primary mb-4">E-Mail verifiziert!</h2>
        <p>{message}</p>
        <Link
          to="/login"
          className="mt-4 inline-block bg-primary text-white px-4 py-2 rounded"
        >
          Jetzt anmelden
        </Link>
      </motion.div>
    );
  }

  return (
    <motion.div
      className="max-w-md mx-auto bg-white p-8 rounded shadow mt-10"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="text-2xl font-heading text-primary mb-6 text-center">
        Konto verifizieren
      </h2>
      {status === 'error' && (
        <div className="bg-red-100 text-red-700 p-2 rounded mb-4">
          {message}
        </div>
      )}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block font-semibold mb-1">E-Mail</label>
          <input
            type="email"
            className="w-full p-2 border rounded"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block font-semibold mb-1">Verifizierungscode</label>
          <input
            type="text"
            className="w-full p-2 border rounded"
            value={verificationCode}
            readOnly
          />
        </div>
        <button
          type="submit"
          className="w-full bg-primary text-white py-2 rounded hover:bg-orange-600 transition"
        >
          Verifizieren
        </button>
      </form>
    </motion.div>
  );
};

export default VerifyAccount;
